import { useRef } from "react";
import { useReactAudioContext } from "@tmsw/powerups.audio.provider";
import type { ToneAudioBuffer } from "tone";

export type UsePlayerProps = { name: string, url: string | ToneAudioBuffer | AudioBuffer, callback?: () => void }

/**
 * @param { name: string, url: string | ToneAudioBuffer | AudioBuffer, callback?: () => void } options
 * @returns
 */
export function usePlayer(options:UsePlayerProps) {
  const rac = useReactAudioContext();
  const playerRef = useRef(rac.addPlayer(options));
  return playerRef.current;
}

export default usePlayer;